import React from 'react';

export default function CompliancePolicy() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Compliance & Policy</h1>
      <p className="text-gray-500">Halaman Compliance & Policy</p>
    </div>
  );
}
